import { useCallback, useSyncExternalStore } from 'react';

import {
  rpaRecorderBridge,
  type RpaRecorderBridge,
  type RpaRecorderStatus,
} from '@/features/rpa/recorder/api/recorder-bridge';

export function useRecorderStatus(
  bridge: RpaRecorderBridge = rpaRecorderBridge
): RpaRecorderStatus {
  const subscribe = useCallback(
    (listener: () => void) => bridge.subscribe(listener),
    [bridge]
  );
  const getSnapshot = useCallback(() => bridge.getStatus(), [bridge]);
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
